export default __webpack_public_path__ + "static/max-8303cbdb1171f8729b2363de609a8a33.png";